import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pause\"><path fill=\"#333333\" d=\"M512 0C229.7 0 0 229.7 0 512s229.7 512 512 512 512-229.7 512-512S794.3 0 512 0z m-63.4 655.2c0 21.8-17.7 39.5-39.5 39.5s-39.5-17.7-39.5-39.5V368.8c0-21.8 17.7-39.5 39.5-39.5s39.5 17.7 39.5 39.5v286.4z m205.8 0c0 21.8-17.7 39.5-39.5 39.5s-39.5-17.7-39.5-39.5V368.8c0-21.8 17.7-39.5 39.5-39.5s39.5 17.7 39.5 39.5v286.4z m0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pause.svg
// module id = mQwT
// module chunks = 65